import { Component, Input, OnInit } from '@angular/core';
@Component({
    selector: 'simple-icons-douban',
    template: `<svg class="simple-icons {{ className }}" [style.width]="size" [style.height]="size" [style.fill]="color" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><title>Douban icon</title><path d="M.643.92v2.412h22.714V.92H.643zm1.974 4.926v9.42h18.764v-9.42H2.617zm2.72 2.408H18.69v4.605H5.338V8.254zm1.657 7.412l-2.512.938c1.037 1.461 1.87 2.825 2.512 4.091H0v2.385h24v-2.385h-6.678c.818-1.176 1.589-2.543 2.303-4.091l-2.73-.938a29.952 29.952 0 01-2.479 5.03h-4.75c-.786-1.962-1.677-3.641-2.672-5.03Z"/></svg>`,
    styles: []
})
export class SimpleIconsDoubanComponent implements OnInit {
    @Input() size: string = '100%';
    @Input() color: string = '#007722';
    @Input() className: string = 'simple-icons-douban'
    constructor() {}
    ngOnInit(): void {}
}
